import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@repo/ui";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import withAuth from "../../../../hoc/withAuth/withAuth";
import { useAppSelector } from "../../../../hooks/useAppDispatch";
import { RootState } from "../../../../redux/store";
import { generateGetURL } from "../../../../services/mediaApiService";
import placeholderImage from "../../../../assets/placeholders/picture.jpg";
import undoIcon from "../../../../assets/icons/undo _white.svg";
import StepIndicator from "../../../../components/StepIndicator/StepIndicator";
import { getWithdrawSteps } from "../../constants/steps";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_WithdrawPage_WithdrawPageSuccess";

const WithdrawPageSuccess: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const steps = getWithdrawSteps(t);

  const navigate = useNavigate();
  const { profilePicture } = useAppSelector(
    (state: RootState) => state.giftTable
  );
  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfileImage = async () => {
      if (profilePicture) {
        try {
          const media = await generateGetURL(profilePicture);
          setProfileImageUrl(media.signedURL);
        } catch (error) {
          console.error("Error fetching profile picture:", error);
          setProfileImageUrl(null);
        }
      }
    };

    fetchProfileImage();
  }, [profilePicture]);

  const handleFinish = () => {
    navigate("/my-table");
  };

  return (
    <PageContainer>
      <div className="mt-16"></div>
      <StepIndicator steps={steps} currentStep={4} progressPercentage={100} />
      <AnimatedCard className="bg-white max-w-lg w-full">
        <h1 className="text-center font-bold text-xl text-primary">
          {t("successTitle")}
        </h1>
        <p className="text-center text-gray-600 mt-4">{t("successMessage")}</p>
        <div className="flex flex-col items-center mt-6 space-y-4">
          <div className="relative w-24 h-24 rounded-full overflow-hidden">
            <img
              src={profileImageUrl || placeholderImage}
              alt={t("successTitle")}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <Button
          label={
            <div className="flex items-center justify-between">
              <span>{t("finishButton")}</span>
              <img
                src={undoIcon}
                alt={t("finishButton")}
                className="ml-2 h-4 w-4"
              />
            </div>
          }
          onClick={handleFinish}
          type="primary"
          className="w-full mt-6"
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(WithdrawPageSuccess));
